function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
var _excluded = ["component", "permission", "feature"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null)
    return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0)
            continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
        target[key] = source[key];
    }
} return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
import { Suspense } from 'react';
import { Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';
import { AppLayout, Loader, MainContent, SkipLink, useBreakpoints } from '@nordlayer/rivendell-ui';
import { useFeatures } from 'flagged';
import { Can } from '@nordvpn/teams.core/lib/atoms/Permissions';
import WithLoader from '@nordvpn/teams.core/lib/hocs/withLoader';
import MissingPermissions from '@nordvpn/teams.core/lib/pages/403';
import { Header } from 'components/organisms/HeaderNew';
import { Navigation } from 'components/organisms/Navigation';
import { getAvailableRedirectPath } from 'utils/routing/getAvailableRedirectPath';
import { getPathWithRegion, getRedirectPathItemsForRegion, getRegionFromSearch, isPathAllowedForRegion } from 'utils/routing/regionAvailability';
import { useAccount } from 'api/Account/queries';
import { useAreFeaturesLoaded } from 'api/FeatureFlags/queries';
import { PageWrapper, StyledContainer } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var MainContainer = function MainContainer(_ref) {
    var Component = _ref.component, permission = _ref.permission, feature = _ref.feature, rest = _objectWithoutProperties(_ref, _excluded);
    var features = useFeatures();
    var areFeaturesLoaded = useAreFeaturesLoaded();
    var _useLocation = useLocation(), pathname = _useLocation.pathname, search = _useLocation.search;
    var _useAccount = useAccount(), account = _useAccount.data;
    var _useBreakpoints = useBreakpoints(), isDesktop = _useBreakpoints.isDesktop;
    var region = getRegionFromSearch(search);
    // Feature flags load asynchronously, so `features` is an empty object on the first render.
    // Without this guard a feature-gated route redirects away before its flag has arrived.
    if (!!feature && !areFeaturesLoaded) {
        return /*#__PURE__*/ _jsx(Loader, {
            centered: true
        });
    }
    if (!!feature && !(features !== null && features !== void 0 && features[feature])) {
        return /*#__PURE__*/ _jsx(Redirect, {
            to: "/"
        });
    }
    if (!isPathAllowedForRegion(pathname, region)) {
        var _account$permissions;
        var redirectPath = getPathWithRegion(getAvailableRedirectPath(getRedirectPathItemsForRegion(region), (_account$permissions = account === null || account === void 0 ? void 0 : account.permissions) !== null && _account$permissions !== void 0 ? _account$permissions : []), region);
        return /*#__PURE__*/ _jsx(Redirect, {
            to: redirectPath
        });
    }
    var RouteView = /*#__PURE__*/ _jsx(Can, {
        permission: permission,
        passThrough: true,
        children: function children(allowed) {
            return allowed ? /*#__PURE__*/ _jsx(Component, _objectSpread({}, rest)) : /*#__PURE__*/ _jsx(MissingPermissions, {
                withHeader: false
            });
        }
    });
    return /*#__PURE__*/ _jsx(AppLayout, {
        skipLink: /*#__PURE__*/ _jsx(SkipLink, {}),
        navigation: /*#__PURE__*/ _jsx(Navigation, {
            isDesktop: isDesktop,
            fullName: (account === null || account === void 0 ? void 0 : account.name) || ''
        }),
        content: /*#__PURE__*/ _jsx(PageWrapper, {
            children: /*#__PURE__*/ _jsxs(StyledContainer, {
                "data-testid": "main-container2",
                children: [isDesktop && /*#__PURE__*/ _jsx(Header, {
                        currentAccount: account
                    }), /*#__PURE__*/ _jsx(Suspense, {
                        fallback: /*#__PURE__*/ _jsx("div", {
                            "data-testid": "suspense-tree-page",
                            children: /*#__PURE__*/ _jsx(WithLoader, {})
                        }),
                        children: /*#__PURE__*/ _jsx(MainContent, {
                            "data-testid": "page-content",
                            children: RouteView
                        })
                    })]
            })
        })
    });
};
